// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const baseNav = [
  { title: 'dashboard', path: '/dashboard/app', icon: icon('ic_analytics') },
  { title: 'role & system guide', path: '/dashboard/guide', icon: icon('ic_analytics') },
  { title: 'summary account', path: '/dashboard/summary', icon: icon('ic_analytics') },
  { title: 'president', path: '/dashboard/president', icon: icon('ic_user') },
  { title: 'financials', path: '/dashboard/financials', icon: icon('ic_user') },
  { title: 'user', path: '/dashboard/users', icon: icon('ic_user') },
  { title: 'savings', path: '/dashboard/savingss', icon: icon('naira') },
  { title: 'loan', path: '/dashboard/loanuser', icon: icon('naira') },
  { title: 'shares', path: '/dashboard/sharesuser', icon: icon('naira') },
  { title: 'ileya savings', path: '/dashboard/ileyasavingsuser', icon: icon('naira') },
  { title: 'development', path: '/dashboard/devuser', icon: icon('naira') },
  { title: 'minutes', path: '/dashboard/minuser', icon: icon('naira') },
  { title: 'welfare', path: '/dashboard/weluser', icon: icon('naira') },
  { title: 'takaful', path: '/dashboard/takafuluser', icon: icon('naira') },
  { title: 'special account', path: '/dashboard/speaccuser', icon: icon('naira') },
  { title: 'business', path: '/dashboard/businessuser', icon: icon('naira') },
  { title: 'business overview', path: '/dashboard/business-overview', icon: icon('ic_analytics') },
  { title: 'loan overview', path: '/dashboard/loan-overview', icon: icon('ic_analytics') },
  { title: 'account reconciliation', path: '/dashboard/reconciliation', icon: icon('ic_analytics') },
  { title: 'activity logs', path: '/dashboard/logs', icon: icon('ic_analytics') },
];

// safe parse localStorage
const getStoredUser = () => {
  try {
    const s = localStorage.getItem('user') || localStorage.getItem('profile');
    return s ? JSON.parse(s) : null;
  } catch {
    return null;
  }
};

// helper: normalize roles/role fields and check by substring (fallback for mismatches)
const normalizeRolesString = (u) => {
  if (!u) return '';
  // roles may be array or string; role may be single string; also check other flags
  const parts = [];
  if (Array.isArray(u.roles)) {
    parts.push(...u.roles.map((r) => (typeof r === 'object' && r !== null ? (r.name || '') : String(r))));
  } else if (u.roles) {
    parts.push(typeof u.roles === 'object' && u.roles !== null ? (u.roles.name || '') : String(u.roles));
  }
  if (u.role) {
    parts.push(Array.isArray(u.role) ? u.role.join(' ') : (typeof u.role === 'object' && u.role !== null ? (u.role.name || '') : String(u.role)));
  }
  if (u.roleName) parts.push(String(u.roleName));
  // include flags
  if (u.isAdmin) parts.push('admin');
  if (u.isPresident) parts.push('president');
  if (u.isBusiness) parts.push('business');
  return parts.join(' ').toLowerCase().replace(/role_/g, '');
};

export const getNavConfig = (paramUser) => {
  const storedUser = paramUser || getStoredUser();
  const viewAsRole = sessionStorage.getItem('mtc_view_as_role');

  let rolesString = '';
  if (viewAsRole) {
    rolesString = viewAsRole.toLowerCase().replace(/role_/g, '');
  } else {
    rolesString = normalizeRolesString(storedUser || {});
  }

  const isAdmin = rolesString.includes('admin') || (!viewAsRole && Boolean(storedUser?.isAdmin));
  const isPresident = rolesString.includes('president') || (!viewAsRole && Boolean(storedUser?.isPresident));
  const isRegistrar = rolesString.includes('registrar') || rolesString.includes('secretary');
  const isFinancial = rolesString.includes('financial');
  const isFinancialII = rolesString.includes('financial_2');
  const isFinancialIII = rolesString.includes('financial_3');
  const isFinancialI =
    (isFinancial && !isFinancialII && !isFinancialIII) ||
    rolesString.includes('financial_1');
  const isBusiness = rolesString.includes('business') || (!viewAsRole && Boolean(storedUser?.isBusiness));

  const showAdmin = (isAdmin || isFinancial || isBusiness) && !isPresident;

  return baseNav.filter((item) => {
    const t = String(item.title || '').toLowerCase();
    if ((t === 'financials' || t === 'admin') && !showAdmin) return false;
    if (t === 'president' && !isPresident) return false;
    if (t === 'user' && !(isAdmin || isPresident || isRegistrar || isFinancial)) return false;
    if (t === 'summary account' || t === 'summary') {
      if (!(isAdmin || isPresident || isFinancial)) return false;
    }
    if (t === 'account reconciliation' || t === 'reconciliation') {
      if (!(isAdmin || isFinancial || isPresident)) return false;
    }
    if ((t === 'business overview') && !(isAdmin || isBusiness || isPresident)) return false;
    if ((t === 'loan overview') && !(isAdmin || isPresident || isFinancialI)) return false;
    if (t === 'activity logs' || t === 'logs') {
      if (!(isAdmin || isPresident)) return false;
    }
    return true;
  });
};

const navConfig = getNavConfig();
export default navConfig;
